import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Phases_getInstance1n7sbxr3lcpvf as Phases_getInstance } from '../../request/HttpRequestPipeline.mjs';
import {
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  Sender4pyqqer9k7up as Sender,
  Plugin_getInstance1dclwrituae7c as Plugin_getInstance,
} from '../HttpSend.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../../request/HttpRequest.mjs';
import { plugin3vxt624hnu3pv as plugin } from '../HttpClientPlugin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SetupRequest$install$slambdaClass;
function SetupRequest$install$slambda() {
  if (SetupRequest$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.j5v_1 = $handler;
      }
      *i5g($this$intercept, it, $completion) {
        yield* this.j5v_1($this$intercept.x4r_1, $completion);
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.i5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    SetupRequest$install$slambdaClass = $;
  }
  return SetupRequest$install$slambdaClass;
}
function SetupRequest$install$slambda_0($handler) {
  var i = new (SetupRequest$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.i5g($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var SetupRequestClass;
function SetupRequest() {
  if (SetupRequestClass === VOID) {
    class $ {
      k5v(client, handler) {
        var tmp = Phases_getInstance().z5m_1;
        client.p5g_1.b4s(tmp, SetupRequest$install$slambda_0(handler));
      }
      e5n(client, handler) {
        return this.k5v(client, (!(handler == null) ? isSuspendFunction(handler, 1) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SetupRequest');
    SetupRequestClass = $;
  }
  return SetupRequestClass;
}
var SetupRequest_instance;
function SetupRequest_getInstance() {
  return SetupRequest_instance;
}
var SenderClass;
function Sender_0() {
  if (SenderClass === VOID) {
    class $ {
      constructor(httpSendSender, coroutineContext) {
        this.f5q_1 = httpSendSender;
        this.g5q_1 = coroutineContext;
      }
      sv() {
        return this.g5q_1;
      }
      *h5q(requestBuilder, $completion) {
        return yield* this.f5q_1.j5t(requestBuilder, $completion);
      }
    }
    initMetadataForClass($, 'Sender', VOID, VOID, [CoroutineScope()], [1]);
    SenderClass = $;
  }
  return SenderClass;
}
var Send$install$slambdaClass;
function Send$install$slambda() {
  if (Send$install$slambdaClass === VOID) {
    class $ {
      constructor($handler, $client) {
        this.l5v_1 = $handler;
        this.m5v_1 = $client;
      }
      *n5v($this$intercept, request, $completion) {
        return yield* this.l5v_1(new (Sender_0())($this$intercept, this.m5v_1.o5g_1), request, $completion);
      }
      md(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Sender()) : false) ? p1 : THROW_CCE();
        return this.n5v(tmp, p2 instanceof HttpRequestBuilder() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    Send$install$slambdaClass = $;
  }
  return Send$install$slambdaClass;
}
function Send$install$slambda_0($handler, $client) {
  var i = new (Send$install$slambda())($handler, $client);
  var l = ($this$intercept, request, $completion) => i.n5v($this$intercept, request, $completion);
  l.$arity = 2;
  return l;
}
var SendClass;
function Send() {
  if (SendClass === VOID) {
    class $ {
      o5v(client, handler) {
        var tmp = plugin(client, Plugin_getInstance());
        tmp.z5t(Send$install$slambda_0(handler, client));
      }
      e5n(client, handler) {
        return this.o5v(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Send');
    SendClass = $;
  }
  return SendClass;
}
var Send_instance;
function Send_getInstance() {
  return Send_instance;
}
//region block: init
SetupRequest_instance = new (SetupRequest())();
Send_instance = new (Send())();
//endregion
//region block: exports
export {
  Send_instance as Send_instance2se4t9sd7p3bp,
  SetupRequest_instance as SetupRequest_instance2wgomqglvou5t,
  Sender_0 as Sender1wtdgti85uk42,
};
//endregion

//# sourceMappingURL=CommonHooks.mjs.map
